import Logo from "../../assets/logo/logo-04.png";

function Index() {
  return (
    <div className="flex justify-center items-center h-screen bg-[#fcf3e8]  ">
      <div className="flex flex-col items-center">
        <img src={Logo} alt="Logo" className="mb-4 w-44 h-44 animate-pulse" />
      </div>
    </div>
  );
}

export default Index;
